export default "__VITE_ASSET__9ivDP3bi__"